var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.4997,
    cy: 6.35714,
    r: 4.70714,
    stroke: "#4F4A62",
    strokeWidth: 1.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75939 12.1817L4.62551 13.0687C3.64133 13.4778 3 14.439 3 15.5048C3 16.9618 4.18113 18.1429 5.63814 18.1429H15.331C16.805 18.1429 18 16.948 18 15.4739C18 14.4217 17.3818 13.4677 16.4215 13.0378L14.5895 12.2177C13.8483 11.8859 13.0453 11.7144 12.2332 11.7144H9.10132C8.29751 11.7144 7.50163 11.8732 6.75939 12.1817Z",
    stroke: "#4F4A62",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyProfileIcon);
export default __webpack_public_path__ + "static/media/my-profile-icon.b1983aa75b2843112ff5a8995384bbb8.svg";
export { ForwardRef as ReactComponent };